// const URL = "https://irc.pavanreddy.in";
// const URL = "http://64.227.175.51:8080";
// const URL = "http://localhost:8080";
const URL="https://api-dsr.firstpartnerconsulting.com";

// const UI_URL = "http://localhost:3000";
const UI_URL = "https://dsr.firstpartnerconsulting.com";

const MAIN_URL = URL;

export { MAIN_URL, UI_URL };